import AdminPanelSettingsRounded from '@mui/icons-material/AdminPanelSettingsRounded';
import HelpOutlineRounded from '@mui/icons-material/HelpOutlineRounded';
import InsightsRounded from '@mui/icons-material/InsightsRounded';
import type { SvgIconComponent } from '@mui/icons-material';

export interface NavItem {
  to: string;
  label: string;
  icon: SvgIconComponent;
  soAdmin?: boolean;
  soAluno?: boolean;
}

/** Navegação principal. "Professor" só aparece para os e-mails de ADMIN_EMAILS. */
export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Minhas notas', icon: InsightsRounded, soAluno: true },
  { to: '/como-funciona', label: 'Como funciona', icon: HelpOutlineRounded },
  { to: '/admin', label: 'Professor', icon: AdminPanelSettingsRounded, soAdmin: true },
];

export function itensVisiveis(eu: { admin: boolean; vinculo: unknown }) {
  return NAV_ITEMS.filter((i) => (!i.soAdmin || eu.admin) && (!i.soAluno || eu.vinculo));
}

export function activeNavItem(pathname: string, itens: NavItem[] = NAV_ITEMS) {
  const match = [...itens]
    .sort((a, b) => b.to.length - a.to.length)
    .find((item) => (item.to === '/' ? pathname === '/' || pathname.startsWith('/disciplina') : pathname.startsWith(item.to)));
  return match?.to ?? false;
}
